var React = require('react');

function TemplateEditor (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"44","height":"46","rx":"8","fill":"#064861","key":0}),React.createElement("path",{"d":"M12 34V30H32V34H12ZM16 26H17.4L25.2 18.225L23.775 16.8L16 24.6V26ZM14 28V23.75L25.2 12.575C25.3833 12.3917 25.5958 12.25 25.8375 12.15C26.0792 12.05 26.3333 12 26.6 12C26.8667 12 27.125 12.05 27.375 12.15C27.625 12.25 27.85 12.4 28.05 12.6L29.425 14C29.625 14.1833 29.7708 14.4 29.8625 14.65C29.9542 14.9 30 15.1583 30 15.425C30 15.675 29.9542 15.9208 29.8625 16.1625C29.7708 16.4042 29.625 16.625 29.425 16.825L18.25 28H14Z","fill":"#FFD301","key":1})]);
}

TemplateEditor.defaultProps = {"width":"44","height":"46","viewBox":"0 0 44 46","fill":"none"};

module.exports = TemplateEditor;

TemplateEditor.default = TemplateEditor;
